var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTainanVideoLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 786,
    height: 754,
    viewBox: "0 0 786 754",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M786 351.668L771.303 271.403L398.57 375.049L753.302 223.791L710.972 153.209L397.543 373.331L677.142 114.397L612.288 62.0056L395.963 372.06L566.715 36.6738L487.158 8.80021L394.03 371.38L435.333 0H350.672L391.97 371.38L298.842 8.80021L219.29 36.6738L390.037 372.06L173.712 62.0056L108.858 114.397L388.463 373.331L75.0281 153.209L32.7033 223.791L387.43 375.049L14.7029 271.403L0 351.668L387.076 377L0 402.332L14.7029 482.597L387.43 378.951L32.7033 530.209L75.0281 600.791L388.463 380.669L108.858 639.603L173.712 691.994L390.037 381.94L219.29 717.326L298.842 745.2L391.97 382.62L350.672 754H435.333L394.03 382.62L487.158 745.2L566.715 717.326L395.963 381.94L612.288 691.994L677.142 639.603L397.543 380.669L710.972 600.791L753.302 530.209L398.57 378.951L771.303 482.597L786 402.332L398.929 377L786 351.668Z",
    fill: "url(#paint0_radial_219_49630)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_219_49630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(393 377) rotate(89.9303) scale(312.94 326.221)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.473958,
    stopColor: "#FA9435"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCD9F",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTainanVideoLight);
export default __webpack_public_path__ + "static/media/tainanVideo_light.75395bda80c6037ee65a8e41969a1e72.svg";
export { ForwardRef as ReactComponent };